module.exports = __webpack_public_path__ + "static/media/illustration-1.cc3cbc2c.svg";